import { trackEvent } from '@fs/zion-analytics'
import { getSessionStorageItem, setSessionStorageItem } from '../../../shared/helpers/sessionStorage'
import scrollToTop from '../../../shared/helpers/scrollToTop'
import handleReducerSimpleSetter from '../../../shared/helpers/handleReducerSimpleSetter'
import getReducerHandler from '../../../shared/helpers/getReducerHandler'

const ACTIONS = Object.freeze({
  INIT_AAM: 'INIT_AAM',
  STATE_UPDATE: 'STATE_UPDATE',
  UPDATE_TILE_DATA: 'UPDATE_TILE_DATA',
  UPDATE_ATF_OPTION: 'UPDATE_ATF_OPTION',
  ADD_GUEST_ANCESTOR: 'ADD_GUEST_ANCESTOR',
  UPDATE_ANCESTOR_BIRTH_YEAR: 'UPDATE_ANCESTOR_BIRTH_YEAR',
})

const AamInitialState = {
  isLoading: true,
  isGuestUser: false,
  isAccessible: false,
  options: {},
  tree: [],
  tileData: [],
  year: '',
  fullName: '',
  firstName: '',
  lastName: '',
  names: [],
  countryCode: '',
  initialTileDataRequested: false,
  isAddTreeFlowShowing: false,
  atfGuestOptionSelected: false,
  guestTree: [],
  showNamesInRomanScript: false,
}

/*
 * --- INDIVIDUAL ACTION HANDLERS ---
 * (Set multiple values & merge/processing logic only, otherwise use handleReducerSimpleSetter)
 */

const handleInitAam = (state, action) => {
  const guestTreeFromStorage = getSessionStorageItem('guestTree') ?? []
  let guestTree = guestTreeFromStorage
  if (guestTree.length !== 0 && action.data.isGuestUser) {
    const personIndex = guestTree.findIndex((p) => p.atn === action.data.guestUser.atn)
    if (personIndex === -1) guestTree = [...guestTree, action.data.guestUser]
  }
  const next = { ...state, ...action.data, isLoading: false, guestTree }
  trackEvent({ event_name: action.type })
  scrollToTop()
  return next
}

const handleUpdateTileData = (state, action) => ({
  ...state,
  year: action.data.year,
  tileData: action.data.tileData,
  firstName: action.data.firstName,
  lastName: action.data.lastName,
  fullName: action.data.fullName,
  names: action.data.names,
  displayName: action.data.displayName,
})

const handleAddGuestAncestor = (state, action) => {
  const guestTree = [...state.guestTree]
  const idx = guestTree.findIndex((p) => p.atn === action.data.atn)
  if (idx === -1) guestTree.push(action.data)
  else guestTree.splice(idx, 1, action.data)
  setSessionStorageItem({ guestTree })
  return { ...state, guestTree }
}

const handleUpdateAncestorBirthYear = (state, action) => {
  // Preserve original (non-mutating) intent; logic appears to be incomplete intentionally
  state.tree
    .filter((person) => person.personId === action.data.personId)
    .map((person) => person.dob === action.data.year)
  return { ...state }
}

// --- Handlers registry ---
const handlers = {
  [ACTIONS.INIT_AAM]: handleInitAam,
  [ACTIONS.STATE_UPDATE]: handleReducerSimpleSetter,
  [ACTIONS.UPDATE_TILE_DATA]: handleUpdateTileData,
  [ACTIONS.UPDATE_ATF_OPTION]: handleReducerSimpleSetter,
  [ACTIONS.ADD_GUEST_ANCESTOR]: handleAddGuestAncestor,
  [ACTIONS.UPDATE_ANCESTOR_BIRTH_YEAR]: handleUpdateAncestorBirthYear,
}

const aamReducer = (state, action) => getReducerHandler(state, action, handlers)

export { AamInitialState, aamReducer, ACTIONS }
